import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=690d7e52&scoped=true&"
import script from "./TrashIcon.vue?vue&type=script&lang=js&"
export * from "./TrashIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrashIcon.vue?vue&type=style&index=0&id=690d7e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d7e52",
  null
  
)

export default component.exports